<template>
  <div>
    <b-card>
      <!-- <b-tabs
        pills
        card
        vertical
        justified
        nav-wrapper-class="col-2"
        active-nav-item-class="bg-sgs-red"
      > -->
      <!-- <b-tab title="Basic Information"> -->
      <b-form @submit="onSubmit" @reset="onReset">
        <h5>Log-in Information</h5>

        <InputText
          id="text-project-id"
          label="Project ID:"
          v-model="form.project_id"
          placeholder="Enter unique project identifier"
          help="This also serves as the project login."
        />

        <InputPassword
          id="text-password"
          label="Password:"
          v-model="form.password"
          placeholder="Enter password"
          help="Leave blank to keep existing password"
          :required="require_password"
        />

        <InputPassword
          id="text-confirm-password"
          label="Confirm Password:"
          v-model="form.confirm_password"
          placeholder="Confirm password"
          :required="require_password"
        />

        <h5>Project information</h5>

        <InputText
          id="text-project-name"
          label="Project name:"
          v-model="form.project_name"
          placeholder="Enter project name"
        />

        <InputTextArea
          id="text-area-project-description"
          label="Project description:"
          v-model="form.project_description"
          placeholder="Please provide project details"
        />

        <InputText
          id="text-school-name"
          label="School:"
          v-model="form.school_name"
          placeholder="Enter name of school"
          list="list-school"
        />
        <b-datalist id="list-school">
          <option v-for="one_school in school" :key="one_school">
            {{ one_school }}
          </option>
        </b-datalist>

        <InputText
          id="text-school-scg"
          label="School Community Group:"
          v-model="form.school_scg"
          placeholder="Enter name of school community group"
          list="list-scg"
        />
        <b-datalist id="list-scg">
          <option v-for="one_scg in scg" :key="one_scg">
            {{ one_scg }}
          </option>
        </b-datalist>

        <br />
        <b-row>
          <b-col cols="4" />
          <b-col>
            <b-button type="reset" variant="danger" block>Reset</b-button>
          </b-col>
          <b-col>
            <b-button type="submit" variant="primary" block>Submit</b-button>
          </b-col>
        </b-row>
      </b-form>
      <!-- </b-tab> -->
      <!-- </b-tabs> -->
    </b-card>
  </div>
</template>

<script>
// import InputSelect from "@/components/form/InputSelect.vue";
import InputTextArea from "@/components/form/InputTextArea.vue";
import InputPassword from "@/components/form/InputPassword.vue";
// import InputNumber from "@/components/form/InputNumber.vue";
// import InputDate from "@/components/form/InputDate.vue";
// import InputRadio from "@/components/form/InputRadio.vue";
// import InputCurrency from "@/components/form/InputCurrency.vue";
// import InputYear from "@/components/form/InputYear.vue";
import InputText from "@/components/form/InputText.vue";
import school from "@/data/school.json";
import scg from "@/data/scg.json";

export default {
  name: "OpportunityForm",
  props: {
    require_password: { type: Boolean, default: false },
    data: { type: Object },
  },
  components: {
    // InputSelect,
    // InputNumber,
    // InputDate,
    // InputRadio,
    // InputCurrency,
    // InputYear,
    InputText,
    InputTextArea,
    InputPassword,
  },
  data() {
    return {
      form: {
        project_id: null,
        project_name: null,
        project_description: null,
        password: null,
        confirm_password: null,
        school_name: null,
        school_scg: null,
      },
      school,
      scg,
      show: true,
    };
  },

  methods: {
    onReset() {
      this.form.every((i) => {
        i = null;
        return i;
      });
      // Reset our form values

      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.$emit("onSubmit", this.form);
    },
  },
  beforeMount() {
    if (this.data) {
      this.form = this.data;
    }
  },
  computed: {
    characters_left() {
      let char_left = 1000 - this.form.description.length;
      if (char_left >= 0) return char_left + " characters left";
      else return Math.abs(char_left) + " characters too long";
    },
  },
  watch: {
    "form.onshore_approval_date": function (val) {
      console.log(val);
    },
    data: function (val) {
      this.form = val;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
